import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectProductsConfigsLoading = (store: StoreSchema) =>
    store.configurations.loading

export const selectProductsConfigs = (store: StoreSchema) =>
    store.configurations.productsConfigurations

export const selectOneProductConfig = (guid: string) => createSelector(
    [selectProductsConfigs],
    (productsConfigs) => productsConfigs[guid]?.configuration
)

export const selectOneProductConfigSchema = (guid: string) => createSelector(
    [selectProductsConfigs],
    (productsConfigs) => productsConfigs[guid]?.schema
)
export const selectOneProductSchemaVersion = (guid: string) => createSelector(
    [selectProductsConfigs],
    (productsConfigs) => productsConfigs[guid]?.schema_version
)

export const selectProductsConfigsInterim = (store: StoreSchema) =>
    store.configurations.productsConfigurationsInterim

export const selectProductsConfigsDefault = (store: StoreSchema) =>
    store.configurations.productsConfigurationsDefault

export const selectInvalidFields = (store: StoreSchema) =>
    store.configurations.invalidFields

export const selectUnsaved = (store: StoreSchema) =>
    store.configurations.unsaved

export const selectConfigsFetchingError = (store: StoreSchema) =>
    store.configurations.fetchingError

export const selectConfigIsChecked = (store: StoreSchema) =>
    store.configurations.isChecked

export const selectConfigBit = (configPathArr: string[]) =>
    createSelector([selectProductsConfigs], (productsConfigs) => {
        return configPathArr.reduce((config, pathBit) => {
            return config?.[pathBit] // config is null but inactive block is rendered and selector is fired
        }, productsConfigs)
    })
